// https://app.growthbook.io/features/prcng-698_v1
export const BUNDLING_TOOLKIT_AND_CERTIFICATES_FLAG_NAME = 'prcng-698_v1'
